<div class="slide-over-content">
  <ng-template #analysisDetailsTemplate>
    <app-analysis-details [element]="element"></app-analysis-details>
  </ng-template>
  <ng-container [ngTemplateOutlet]="analysisDetailsTemplate"></ng-container>
</div>
<div class="slide-over-buttons">
  <app-button-group>
    <app-button (pressed)="onFullscreen()" type="ghost">
      <mat-icon icon-left>open_in_full</mat-icon>
      <ng-container i18n="@@shared.fullscreen">Full screen</ng-container>
    </app-button>
  </app-button-group>
</div>
